import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export type PlanLimitState = 'disabled' | 'limited' | 'unlimited';

export interface PlanLimitMeter {
  subject: string;
  period: string;
}

export interface PlanLimit {
  key: string;
  state: PlanLimitState;
  value: number;
  meter?: PlanLimitMeter;
}

export interface AdminPlan {
  id: string;
  code: string;
  displayName: string;
  billingKind: string;
  interval: string;
  amountCents: number;
  currency: string;
  isRecommended: boolean;
  sortOrder: number;
  limits: PlanLimit[];
}

export interface PlanLimitCatalogEntry {
  key: string;
  label: string;
  description: string;
  group: string;
  allowedSubjects: string[];
  allowedPeriods: string[];
  isCapability: boolean;
  defaultMeter?: PlanLimitMeter;
}

@Injectable({ providedIn: 'root' })
export class BillingAdminService {
  #http = inject(HttpClient);

  listPlans(): Promise<AdminPlan[]> {
    return lastValueFrom(
      this.#http.get<AdminPlan[]>(`${environment.baseUrl}/payments/admin/plans`),
    );
  }

  limitCatalog(): Promise<PlanLimitCatalogEntry[]> {
    return lastValueFrom(
      this.#http.get<PlanLimitCatalogEntry[]>(
        `${environment.baseUrl}/payments/admin/limit-catalog`,
      ),
    );
  }

  updatePlanLimits(planCode: string, limits: PlanLimit[]): Promise<AdminPlan> {
    return lastValueFrom(
      this.#http.patch<AdminPlan>(
        `${environment.baseUrl}/payments/admin/plans/${encodeURIComponent(planCode)}/limits`,
        { limits },
      ),
    );
  }
}
